<template>
  <div>
    <graph
      :title="adminText('workflowsAll.visitors_total_number_9bc818d', 'Visitors total number')"
      :data-filter="true"
      :has-data="hasData"
      :value="`${data.totalVisits || 0}`"
      :initial-date-range-option="initialDateRangeOption"
      :initial-date-range="initialDateRange"
      @changeDateRange="changeDateRange($event)"
    >
      <line-chart :data="workflowUi(data)" :options="workflowUi({})" />
    </graph>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { GET_EVENT_VISITOR_PAGE_VISIT_STATS } from '../../../graphql/purchase.graphql'

import LineChart from '../../shared/graphs/line-chart.vue'
import Graph from '../../shared/graphs/graph.vue'
import moment from 'moment'
export default {
  mixins: [WorkflowDisplay],
  name: 'visitors-total-number',
  components: {
    LineChart,
    Graph,
  },
  props: ['eventId', 'initialDateRangeOption', 'initialDateRange', 'eventTemplateId'],
  data() {
    return {
      data: { datasets: [{ data: [] }] },
      endDate: this.initialDateRange[1],
      startDate: this.initialDateRange[0],
    }
  },
  computed: {
    hasData() {
      return this.data.datasets[0].data.length > 0
    },
  },

  methods: {
    changeDateRange(dateRangeObject) {
      this.startDate = moment(dateRangeObject.dateRange[0]).format('YYYY-MM-DD')
      this.endDate = moment(dateRangeObject.dateRange[1]).format('YYYY-MM-DD')
      this.filterByDate()
    },
    async filterByDate() {
      await this.$apollo.queries.getEventVisitorPageVisitStats.refetch()
    },
  },
  apollo: {
    getEventVisitorPageVisitStats: {
      query: GET_EVENT_VISITOR_PAGE_VISIT_STATS,
      variables() {
        return {
          from: this.startDate,
          to: this.endDate,
          eventId: this.eventId,
          eventTemplateId: this.eventTemplateId,
        }
      },
      result({ loading, data }) {
        if (!loading) {
          const {
            getEventVisitorPageVisitStats: { visits, totalVisits },
          } = data

          this.data = {
            totalVisits,
            labels: visits.map(e => moment(e.date).format('D/M')),
            datasets: [{ data: visits.map(e => e.total) }],
          }
        }
      },
    },
  },
}
</script>

<style scoped></style>
